/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Button, DialogActions } from "@mui/material";
import LinkCreateContext from "cms/links/link-selector/context/create";

const LinkDialogBottomActions = () => {
    
    const {
        link,
        handleCreateClose,
        onSaveLink,
        canSave,
        setCanSave,
        setStartClone,
    } = useContext(LinkCreateContext);
    
    const cancelDisabled = false;
    
    const handleSave = (event) => {
        setStartClone(false);
        onSaveLink(link);
        handleCreateClose(event);
    };
    
    const handleCancel = (event) => {
        setCanSave(false);
        setStartClone(false);
        handleCreateClose(event);
    };

    return (
        <DialogActions className="simplicity-link-selector-window-footer">
            <Button
                variant='outlined'
                color='secondary'
                onClick={handleCancel}
                disabled={cancelDisabled}
            >
                Cancel
            </Button>
            {canSave &&
                <>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={handleSave}
                    >
                    Save
                    </Button>
                </>
            }
            {!canSave &&
                <>
                    <Button
                        variant='contained'
                        color='grey'
                        onClick={handleSave}
                        disabled={true}
                    >
                    Save
                    </Button>
                </>
            }

        </DialogActions>
    );
};

export default LinkDialogBottomActions;
